import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";

function Users(props) {
  const { request } = useApi();
  const stateError = useError();
  const messages = message();

  const replaceFeatures = [
    {id: 10, name: "administrator"},
    {id: 20, name: "account"},
    {id: 30, name: "csvReport"},
    {id: 40, name: "customer"},
    {id: 50, name: "info"},
    {id: 60, name: "informationUrls"},
    {id: 70, name: "dtm"},
    {id: 80, name: "dtmSetting"},
    {id: 90, name: "mediaAccounts"},
    {id: 95, name: "mediaCategories"},
    {id: 100, name: "collectionTheme"},
    {id: 9999, name: "log"},
  ];

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 管理者登録";
  }, []);

  const handleSubmit = ({ adminName, desc, email, password, features }) => {
    // 選択した利用可能機能をフォーマッティング
    let selectFeatures = [];
    replaceFeatures.map((value) => {
      if (features[value.name]) {
        selectFeatures.push(value.id);
      }
    })

    request({
      method: "POST",
      url: `admin/users`,
      data: {
        name: adminName,
        desc: desc,
        email: email,
        password: password,
        features: selectFeatures,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/administrator?success=create");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
        />
      }
    />
  );
}
export default withRouter(Users);
